import { PROJECT_STATUS_APROVADO } from 'library/ProjectStatus';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { etapaIsUnlocked } from 'utils/ProjetoUtils';
import SnackbarUtils from 'utils/SnackbarUtils';
import { CustomCard } from '../../../../../components/CustomCard';
import CustomCheckbox from '../../../../../components/CustomCheckbox/CustomCheckbox';
import { CustomNumberField } from '../../../../../components/CustomNumberField';
import { CustomTextField } from '../../../../../components/CustomTextField';
import { GenericProjectCard } from '../../../../../components/GenericProjectCard';
import { HelpButton } from '../../../../../components/HelpButton';
import NewAutoCompleteField from '../../../../../components/NewAutoCompleteField/NewAutoCompleteField';
import { getStepSlug } from '../../../../../library/ProjectSteps';
import { projectEdit } from '../../../../../library/Routes';
import {
  changeProjetoValue,
  registerPreEtapa,
  saveProjeto,
} from '../../../../../store/modules/ProjetoActions';
import { Col } from './../../../../../components/Col';
import { Row } from './../../../../../components/Row';
import { loadEtapasEnsino } from './../../../../../store/modules/EscolasActions';
import styles from './PreEtapa3.scss';
const rootClassName = styles.rootClassName;

class PreEtapa3 extends GenericProjectCard {
  stepIndex = 0;

  validationResults = [false];

  constructor(props) {
    super(props);

    this.state = {
      ...(this.state || {}),
      idEtapasEnsinoChanged: false,
      descricaoTurmaChanged: false,
      quantidadeAlunosTurmaChanged: false,
      sending: false,
    };

    this.props.loadEtapasEnsino();

    this.setValue = this.setValue.bind(this);
    this.toSubmit = this.toSubmit.bind(this);
  }

  idEtapasEnsinoIsValid() {
    return this.props.projeto.idEtapasEnsino.length > 0;
  }

  descricaoTurmaIsValid() {
    return this.props.projeto.descricaoTurma.trim().length > 0;
  }

  quantidadeAlunosTurmaIsValid() {
    return this.props.projeto.quantidadeAlunosTurma > 0;
  }

  changeSendingStatus(status) {
    this.setState({
      ...this.state,
      sending: status,
    });
  }

  toSubmit() {
    if (!this.itemsAreValid(this.validationResults)) {
      return;
    }
    this.changeSendingStatus(true);
    let avaliacao =
      this.props.projeto.avaliacoes.length > this.stepIndex + 1
        ? this.props.projeto.avaliacoes[this.stepIndex]
        : {};
    avaliacao.etapa = this.stepIndex;
    avaliacao.status = PROJECT_STATUS_APROVADO;
    let data = {
      idUsuario: this.props.projeto.idUsuario,
      idEscola: this.props.projeto.idEscola,
      cpfsAssessores: this.props.projeto.cpfsAssessores,
      nome: this.props.projeto.nome,
      cpfsProfessores: this.props.projeto.cpfsProfessores,
      idEtapasEnsino: this.props.projeto.idEtapasEnsino,
      descricaoTurma: this.props.projeto.descricaoTurma,
      quantidadeAlunosTurma: this.props.projeto.quantidadeAlunosTurma,
      codigoCooperativa: this.props.projeto.codigoCooperativa,
      periodoInicial: this.props.projeto.periodoInicial,
      direitoImagem: this.props.projeto.direitoImagem,
      avaliacao,
    };
    if (this.props.projeto.periodoFinal) {
      data.periodoFinal = this.props.projeto.periodoFinal;
    }
    if (this.props.projeto.id) {
      data.id = this.props.projeto.id;
    } else {
      data.consultaPublica = true;
    }
    const saveFunction = this.props.projeto.id
      ? this.props.saveProjeto
      : this.props.registerPreEtapa;
    saveFunction(
      data,
      () => {
        SnackbarUtils.enqueueSnackbar({
          message: this.props.languageValues.successCadastrarPreCadastro,
          options: {
            variant: 'success',
          },
        });
        this.changeSendingStatus(false);
        if (this.props.auth.userPermissions.projetos.edit) {
          this.props.history.push(
            projectEdit.getURLWithParams(
              this.props.projeto.id,
              getStepSlug(this.stepIndex + 1)
            )
          );
        } else if (this.props.auth.userPermissions.projetos.register) {
          this.props.history.push(
            projectEdit.getURLWithParams(this.props.projeto.id, getStepSlug(10))
          );
        }
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.erroCadastrarPreCadastro,
          options: {
            variant: 'error',
          },
        });
        this.changeSendingStatus(false);
      }
    );
  }

  render() {
    this.validationResults = this.state.sending
      ? [false]
      : [
          this.idEtapasEnsinoIsValid(),
          this.descricaoTurmaIsValid(),
          this.quantidadeAlunosTurmaIsValid(),
        ];
    return (
      <CustomCard
        stepIndex={this.stepIndex}
        titleHint={this.props.languageValues.hintPreEtapa}
        CardHeaderPropTypes={{
          title: this.props.languageValues.preCadastro,
        }}
        sending={this.state.sending}
      >
        <form
          className={this.getFormClasses(false)}
          onSubmit={(event) => {
            event.preventDefault();
            this.toSubmit();
          }}
        >
          <Row className='form-row'>
            <Col cols={[12, 12, 12, 12, 12]}>
              <NewAutoCompleteField
                label={this.props.languageValues.etapaDeEnsino}
                placeholder={
                  this.props.escolas.loadingEtapasEnsinoList
                    ? this.props.languageValues.loadingEtapasEnsinoList
                    : ''
                }
                options={this.props.escolas.etapasEnsinoList.map((item) => {
                  return {
                    label: item.nome,
                    value: item.id,
                  };
                })}
                value={this.props.projeto.idEtapasEnsino}
                multiple
                onChange={(value) => {
                  const currValue = value ? value.map((val) => val.value) : [];
                  this.setValue({
                    target: {
                      name: 'idEtapasEnsino',
                      value: currValue,
                    },
                  });
                }}
                loading={this.props.escolas.loadingEtapasEnsinoList}
                loadingMessage={
                  this.props.languageValues.loadingEtapasEnsinoList
                }
                disabled={
                  this.props.lockedAllFields ||
                  !etapaIsUnlocked(
                    this.stepIndex,
                    this.props.projeto.avaliacoes
                  )
                }
                error={!this.idEtapasEnsinoIsValid()}
                helperText={
                  !this.idEtapasEnsinoIsValid()
                    ? this.props.languageValues.validations.etapasEnsino
                        .required
                    : ''
                }
              />
            </Col>
          </Row>
          <Row className='form-row'>
            <Col cols={[12, 6, 6, 6, 6]}>
              <CustomTextField
                label={this.props.languageValues.turma}
                name='descricaoTurma'
                value={this.props.projeto.descricaoTurma}
                onChange={(event) => {
                  this.setValue(event);
                }}
                counter={true}
                maxSize={200}
                error={!this.descricaoTurmaIsValid()}
                disabled={
                  this.props.lockedAllFields ||
                  this.state.sending ||
                  !etapaIsUnlocked(
                    this.stepIndex,
                    this.props.projeto.avaliacoes
                  )
                }
              />
            </Col>
            <Col cols={[12, 6, 6, 6, 6]}>
              <CustomNumberField
                onlyInteger={true}
                onlyPositive={true}
                label={this.props.languageValues.quantidadeDeAlunos}
                name='quantidadeAlunosTurma'
                value={this.props.projeto.quantidadeAlunosTurma}
                onChange={this.setValue}
                error={!this.quantidadeAlunosTurmaIsValid()}
                disabled={
                  this.props.lockedAllFields ||
                  this.state.sending ||
                  !etapaIsUnlocked(
                    this.stepIndex,
                    this.props.projeto.avaliacoes
                  )
                }
              />
            </Col>
          </Row>
          <Row className='form-row'>
            <Col
              cols={[12, 12, 12, 12, 12]}
              className={rootClassName + '-checkbox-col-with-help-button'}
            >
              <CustomCheckbox
                name='direitoImagem'
                label={this.props.languageValues.direitoImagem}
                onChange={(event) => {
                  this.setValue(event);
                }}
                checked={this.props.projeto.direitoImagem || false}
                disabled={
                  this.props.lockedAllFields ||
                  this.state.sending ||
                  !etapaIsUnlocked(
                    this.stepIndex,
                    this.props.projeto.avaliacoes
                  )
                }
              >
                <HelpButton
                  tooltipCallerClassName={
                    rootClassName + '-checkbox-tooltip-caller'
                  }
                  className={rootClassName + '-checkbox-help-button'}
                  text={this.props.languageValues.direitoImagemHint}
                />
              </CustomCheckbox>
            </Col>
          </Row>
          {this.getActionsRow([
            [
              this.getPreviousButton(!this.state.sending),
              this.getFinalyButton(
                this.props.lockedAllFields ||
                  !this.itemsAreValid(this.validationResults),
                this.toSubmit
              ),
            ],
          ])}
        </form>
      </CustomCard>
    );
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  projeto: state.projeto.projetoEditing,
  escolas: state.escolas,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadEtapasEnsino,
      changeProjetoValue,
      registerPreEtapa,
      saveProjeto,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PreEtapa3));
